import {mkNode, removeNode} from '@p4b/utils';

export class Progress {
    public onProgress: (progress: number) => Promise<void> = async () => undefined;
    private progressBox: HTMLDivElement;
    private title: HTMLDivElement;
    private subtext: HTMLDivElement;
    private text1: Text;
    private text2: Text;
    private totalSize: number;
    private currentSize: number;

    constructor(parent: HTMLElement) {
        this.progressBox = mkNode('div', {className: 'progress-panel'});
        this.title = mkNode('div', {parent: this.progressBox, className: 'progress-title'});
        this.subtext = mkNode('div', {parent: this.progressBox, className: 'progress-subtext'});
        //mkNode('div', {parent: this.progressBox, className: 'spinner'});
        const textBox = mkNode('div', {parent: this.progressBox, className: 'progress-text'});
        const span1 = mkNode('span', {parent: textBox});
        const span2 = mkNode('span', {parent: textBox});
        this.text1 = mkNode('text', {parent: span1});
        this.text2 = mkNode('text', {parent: span2});
        this.totalSize = 0;
        this.currentSize = 0;
        parent.appendChild(this.progressBox);
    }

    destroy(): void {
        removeNode(this.progressBox);
    }

    setTitle(title: string): void {
        this.title.innerHTML = title;
    }

    setDescription(description: string): void {
        this.subtext.innerHTML = description;
    }

    setTotalSize(size: number): void {
        this.totalSize = size;
        this.text1.nodeValue = '0';
        this.text2.nodeValue = '%';

    }

    async show(offset = 0): Promise<void> {
        const p = Math.floor(100.0 * (this.currentSize + offset) / this.totalSize);
        this.text1.nodeValue = `${p}`;
        await this.onProgress(offset);
    }

    save(progress: number): void {
        this.currentSize += progress;
    }
}
